import { generateId, type ChatMessage } from "../types";
import type { TabsState } from "../types";
import { createChatSessionId } from "../../shared/utils/sessionId";

export const TASK_GENERATED_MESSAGE_PREFIX = "Generated from task:";
export const CHAT_GENERATED_MESSAGE_PREFIX = "Generated from chat:";

const SYNTHETIC_CITATION_MESSAGE_PREFIXES = [
  TASK_GENERATED_MESSAGE_PREFIX,
  CHAT_GENERATED_MESSAGE_PREFIX,
];

export function isTaskGeneratedMessage(
  message: Pick<ChatMessage, "role" | "content">
): boolean {
  return (
    message.role === "assistant" &&
    typeof message.content === "string" &&
    SYNTHETIC_CITATION_MESSAGE_PREFIXES.some((prefix) => message.content.startsWith(prefix))
  );
}

export function attachSyntheticMessageToSlideTab(
  prev: TabsState,
  params: {
    slideId: string;
    slideIndex: number;
    slideNumber?: number;
    message: ChatMessage;
  }
): TabsState {
  const { slideId, slideIndex, message } = params;
  const slideNumber = params.slideNumber ?? message.slideNumber ?? slideIndex + 1;
  const timestamp = Date.now();

  const existingTab = prev.tabs.find(
    (tab) => !!tab.session.slideId && tab.session.slideId === slideId
  );

  if (existingTab) {
    return {
      ...prev,
      tabs: prev.tabs.map((tab) =>
        tab.id === existingTab.id
          ? {
              ...tab,
              session: {
                ...tab.session,
                slideId,
                slideIndex,
                slideNumber,
                name: `Slide ${slideNumber}`,
                messages: [
                  ...tab.session.messages,
                  { ...message, slideIndex, slideNumber },
                ],
                updatedAt: timestamp,
              },
            }
          : tab
      ),
    };
  }

  const newTab = {
    id: generateId(),
    isLoading: false,
    loadingStatus: "",
    streamingThinking: "",
    visionFeedback: "",
    refinementStep: 0,
    session: {
      id: createChatSessionId(),
      name: `Slide ${slideNumber}`,
      messages: [],
      slideId,
      slideIndex,
      slideNumber,
      createdAt: timestamp,
      updatedAt: timestamp,
    },
  };
  return {
    ...prev,
    tabs: [
      ...prev.tabs,
      {
        ...newTab,
        session: {
          ...newTab.session,
          messages: [{ ...message, slideIndex, slideNumber }],
          updatedAt: timestamp,
        },
      },
    ],
  };
}
